const TextStyles = `
  .text-uppercase {
    text-transform: uppercase;
  }

  .nts-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
`

export default TextStyles
